<template>
  <div class="inform-publish">
    <breadcrumb
      :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'通知管理',src:'/public/inform'},{name:id?'编辑通知':'发布通知'}]"
    ></breadcrumb>
    <div class="inform-publish-wrap">
      <div class="inform-publish-contain">
        <div class="inform-publish-title">
          <input v-model="informForm.name" placeholder="通知标题">
          <div class="switch-wrap">
            <span>置顶</span>
            <el-switch v-model="informForm.top"></el-switch>
          </div>
          <div class="switch-wrap">
            <span>加急</span>
            <el-switch v-model="informForm.urgent"></el-switch>
          </div>
          <el-select class="select-wrap" v-model="informForm.type" clearable placeholder="通知类型">
            <el-option
              v-for="item in typeOption"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </div>
        <editor
          @changeFile="addFile"
          @change="onEditorChange"
          v-if="!loading"
          :defaultContent="this.informForm.content"
        />
        <div class="inform-publish-file_list">
          <div v-for="(item,index) in fileList" :key="index" class="inform-publish-file_item">
            <div>
              <font-awesome-icon
                style="color:#F0722B;margin-right:10px"
                :icon="['fas', 'download']"
              />
              {{item.name}}
              <span style="margin-left:9px; cursor:pointer" @click="delFile(index)">
                <font-awesome-icon :icon="['fas', 'times-circle']"/>
              </span>
            </div>
          </div>
        </div>
        <div class="inform-publish-member">
          <div class="inform-publish-member_num">
            选择收件人（
            <span style="color:#f0722b">{{selectUserNum}}</span>
            <span style="color:#999">/{{allUser.length}}</span> ）
            <el-checkbox v-model="all" @change="handleCheckAll">全选</el-checkbox>
          </div>
          <div class="inform-publish-member_list">
            <div
              v-for="(item,index) in allUser"
              @click="selectMember(index)"
              :key="item.id"
              class="inform-publish-member_item"
            >
              <member-item :name="item.name" :checked="!!item.checked"></member-item>
            </div>
          </div>
          <div class="inform-publish-button">
            <el-button type="primary" @click="handlePublish">{{id?"发布修改":"立即发布"}}</el-button>
            <el-button style="margin-left:20px;" @click="deletePublish">{{id?"取消修改":"取消发布"}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import editor from "@/components/editor";
import memberItem from "@/components/memberItem";
import axios from "@/servies/axios";
import api from "@/servies/api";
export default {
  data() {
    return {
      loading: true,
      id: "",
      canDelete: false,
      typeOption: [],
      fileList: [],
      all: false,
      allUser: [],
      selectUserNum: 0,
      informForm: {
        attachment: "",
        type: "",
        top: false,
        urgent: false,
        content: "",
        name: "",
        userIds: []
      }
    };
  },
  components: {
    breadcrumb,
    editor,
    memberItem
  },
  beforeRouteLeave(to, from, next) {
    if (!this.canDelete) {
      this.$confirm("是否取消发布，跳转至其他页面？", "页面跳转确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          next();
        })
        .catch(() => {});
    } else {
      next()
    }
  },
  created() {
    Promise.all([this.getAllUser(), this.getAllNoticeType()]).then(() => {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDetail();
      } else {
        this.loading = false
      }
    });
  },
  methods: {
    // 获取详情
    getDetail() {
      // 获取详情
      axios
        .get(api.getNoticeById + `\\${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取通知成功", res.data.result);
            this.loading = false;
            this.informForm = res.data.result;
            this.informForm.top = !!this.informForm.top;
            this.informForm.urgent = !!this.informForm.urgent;
            if(this.informForm.attachment=== ''){
              this.fileList = []
            } else {
               this.fileList = this.informForm.attachment.split(",").map(item => {
              let arr = item.split("/");
              return { name: arr[arr.length - 1], path: item };
            })

            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.error("网络错误，请稍后重试");
        });
      axios
        .get(api.getReadUnread + `\\${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取已读和未读的用户成功", res.data.result);
            let checkedUser = res.data.result.isRead.concat(
              res.data.result.unRead
            );
            this.allUser.forEach((item, index) => {
              checkedUser.forEach(item2 => {
                if (item.id === item2.userId) {
                  this.allUser[index].checked = true;
                  this.selectUserNum++;
                }
              });
            });
          } else {
            this.$message.error(res.data.msg);
            console.log(error);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    // 获取所有用户
    async getAllUser() {
      await axios
        .get(api.getAllUser)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取所有用户成功", res.data.result);
            this.allUser = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    //获取所有通知类型
    getAllNoticeType() {
      axios
        .get(api.getAllNoticeType)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取所有通知类型成功", res.data.result);
            this.typeOption = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    onEditorChange(value) {
      this.informForm.content = value;
    },
    // 选择全选
    handleCheckAll(v) {
      if (v === true) {
        this.selectUserNum = this.allUser.length;
      } else {
        this.selectUserNum = 0;
      }
      this.allUser.forEach(element => {
        this.$set(element, "checked", v);
      });
    },
    // 选择发件人
    selectMember(index) {
      if (this.allUser[index].checked) {
        this.selectUserNum--;
        if (this.all) {
          this.all = false;
        }
      } else {
        this.selectUserNum++;
      }
      this.$set(this.allUser[index], "checked", !this.allUser[index].checked);
    },
    // 发布
    handlePublish() {
      if(this.informForm.name === ''){
        this.$message.error('标题不可为空');
        return
      }
      this.informForm.userIds = [];
      this.allUser.forEach(item => {
        if (item.checked === true) {
          this.informForm.userIds.push(item.id);
        }
      });
      this.informForm.top = this.informForm.top ? 1 : 0;
      this.informForm.urgent = this.informForm.urgent ? 1 : 0;
      this.informForm.attachment = this.fileList
        .map(item => {
          return item.path;
        })
        .join(",")
      axios
        .post(api.addOrUpdateNotice, this.informForm)
        .then(res => {
          if (res.data.code === 0) {
            this.roleFormVisible = false;
            this.$message({
              message: "创建通知成功",
              type: "success"
            });
            this.canDelete = true;
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //取消发布
    deletePublish() {
      this.$router.push({ path: "/public/inform" });
    },
    // 添加附件
    addFile(e) {
      let file = e.target.files[0];
      let param = new FormData();
      console.log(file)
      param.append("file", file);
      param.append("fileType", 5);
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.fileList.push({ path: "", name: file.name });
      axios
        .post(api.uploadFile, param, config)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "上传附件成功",
              type: "success"
            });
            this.fileList[this.fileList.length - 1].path = res.data.result;
          } else {
            this.$message.error(res.data.msg);
            this.fileList.pop();
          }
        })
        .catch(error => {
          this.fileList.pop();
          this.$message.error("网络错误，稍后重试");
        });
    },
    // 删除附件
    delFile(index) {
      this.fileList.splice(index, 1);
    }
  }
};
</script>

<style lang="scss">
.inform-publish {
  .inform-publish-wrap {
    padding: 77px 30px 0px 30px;
    .inform-publish-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .inform-publish-title {
        padding-left: 18px;
        display: flex;
        height: 54px;
        align-items: center;
        input {
          -web-kit-appearance: none;
          -moz-appearance: none;
          outline: 0;
          border: 0px;
          flex: 1;
          padding-right: 20px;
          font-size: 16px;
          &::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #bdbbbd;
          }

          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #bdbbbd;
          }

          &:-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: #bdbbbd;
          }
        }
        .switch-wrap {
          font-size: 14px;
          color: #4a4a4a;
          display: flex;
          align-items: center;
          span {
            margin-right: 8px;
          }
        }
        .select-wrap {
          width: 140px;
          height: 100%;
          input {
            height: 54px;
            font-size: 15px;
            border-radius: 0px;
            border-top-right-radius: 4px;
            border-left: 1px #e6e3e3 solid;
          }
        }
      }
      .inform-publish-member {
        .inform-publish-member_num {
          font-size: 14px;
          color: #4a4a4a;
          height: 40px;
          line-height: 40px;
          background: #f8f8f8;
          padding: 0 22px;
          border-top: 1px #e6e3e3 solid;
          border-bottom: 1px #e6e3e3 solid;
        }
        .inform-publish-member_list {
          display: flex;
          flex-wrap: wrap;
          padding: 8px 23px 21px 23px;
          border-bottom: 1px solid #e6e3e3;
          .inform-publish-member_item {
            margin-right: 10px;
            margin-top: 13px;
          }
        }
        .inform-publish-button {
          padding: 24px 28px;
        }
      }
      .inform-publish-file_list {
        display: flex;
        padding: 22px 20px;
        flex-wrap: wrap;
        .inform-publish-file_item {
          margin-right: 10px;
          border-radius: 4px;
          border: 1px solid rgba(230, 227, 227, 1);
          padding: 11px 15px;
        }
      }
    }
  }
}
</style>
